import { Typography } from '@/components/atoms/Typography';
import { useTranslation } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface FAQEmptyStateProps {
  isSearchNoResults?: boolean;
}

function getFaqEmptyCopy(
  isSearchNoResults: boolean | undefined,
  t: ReturnType<typeof useTranslation>['t'],
): { title: string; subtitle: string } {
  if (isSearchNoResults) {
    return {
      title: t('profile.faqSearchNoResultsTitle'),
      subtitle: t('profile.faqSearchNoResultsSubtitle'),
    };
  }
  return {
    title: t('profile.faqEmptyTitle'),
    subtitle: t('profile.faqEmptySubtitle'),
  };
}

export function FAQEmptyState({
  isSearchNoResults,
}: Readonly<FAQEmptyStateProps>) {
  const { t } = useTranslation();
  const { title, subtitle } = getFaqEmptyCopy(isSearchNoResults, t);

  return (
    <View style={styles.emptyState}>
      <Typography variant="headline" color="primary" style={styles.emptyTitle}>
        {title}
      </Typography>
      <Typography variant="body" color="tertiary" style={styles.emptySubtitle}>
        {subtitle}
      </Typography>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyState: {
    alignItems: 'center',
    gap: 8,
    paddingVertical: 24,
  },
  emptyTitle: {
    textAlign: 'center',
    fontWeight: '700',
  },
  emptySubtitle: {
    textAlign: 'center',
    paddingHorizontal: 16,
  },
});
